module.exports = __webpack_public_path__ + "static/media/mssg_menu_en_US.d07e15aa.PNG";